import PropTypes from 'prop-types';
import ReactModal2 from 'react-modal2';
import React from 'react';
import { Gateway } from 'react-gateway';
import classnames from 'classnames';

const Modal = ({ close, children, size, title, className, backdropStyles }) => (
  <Gateway into="modal">
    <ReactModal2
      modalClassName={classnames('c-modal', className, { 'c-modal--small': size === 'small' })}
      backdropClassName="c-modal-wrapper"
      onClose={close}
      backdropStyles={backdropStyles}
    >
      {title &&
      <div className="c-modal__header">
        {title}
      </div>
      }
      <div className="c-modal__body">
        {children}
      </div>
    </ReactModal2>
  </Gateway>
);
Modal.propTypes = {
  close: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', '']),
  title: PropTypes.string,
  className: PropTypes.string,
  backdropStyles: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};
Modal.defaultProps = {
  size: '',
  title: '',
  className: '',
  backdropStyles: {},
};

export default Modal;



// WEBPACK FOOTER //
// ./src/app/components/Modal.jsx